import React from 'react'

import logo from '../../../assets/logo.svg';
import './Header.scss'


export const Header: React.FC = () => {


	return (
		<div className='header'>
			<a href="https://moxio.finance/" className="logo">
				<img className="logo" src={logo} alt='logo'/>
			</a>
		</div>
	)
}